import React from "react";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import RefreshOutlined from "@material-ui/icons/RefreshOutlined";
import Visibility from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChipInput from "material-ui-chip-input";
import ColorPicker from "material-ui-color-picker";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import {
  apiRequest,
  apiBatchRequest,
  apiPost
} from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import RenderLayout from "../../Dashboard/RenderLayout";
import Chip from "@material-ui/core/Chip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import camelCaseKeys from "camelcase-keys";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { FormHelperText } from "@material-ui/core";
import DenseTable from "../../Dashboard/RenderTable";
import { getPropsForData } from "../../../utils/graph_service";
import { removeDuplicates, PaperComponent } from "../../../utils/helper";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const colors = [
  "#D14040",
  "#7F40D1",
  "#2D76E5",
  "#1BBC86",
  "#E2E22D",
  "#92661A",
  "#EB9563",
  "#E5897F",
  "#E24E89",
  "#C063E8",
  "#63B3E8"
];

class ConfigureWidgetData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      masterConfig: undefined,
      chartConfig: false,
      sampleData: null,
      sampleViewData: undefined,
      configuration: null,
      openPreview: false,
      openConfirmPreview: false,
      openViewSampleDataPanel: false,
      sourceList: [],
      param: {
        propertyId: 5,
        startDate: moment()
          .subtract(6, "month")
          .format("MM/DD/yyyy"),
        endDate: moment().format("MM/DD/yyyy")
      },
      isSummaryData: false,
      isForPerformance: false,
      errors: { fields: [], columns: [], filters: [] },
      reportList: []
    };
  }

  /**
   * Onload event
   */
  componentDidMount() {
    this.GetMasterData();
    let configuration = this.props.chartConfig.configuration;
    if (configuration != undefined) {
      configuration = JSON.parse(
        JSON.stringify(configuration || this.props.masterConfig.configuration)
      );
      configuration = JSON.parse(
        configuration || this.props.masterConfig.configuration
      );
    }
    const chartConfig = this.props.chartConfig;
    if (chartConfig.title == undefined) {
      chartConfig.title = this.props.masterConfig.name || "";
    }
    this.setState(
      {
        masterConfig: this.props.masterConfig,
        chartConfig: chartConfig,
        sampleData: this.props.sampleData,
        configuration: configuration || {}
      },
      () => {
        if (chartConfig.isForPerformance == true) {
          this.loadPerformanceAttribute(chartConfig.reportId);
        }
        if (
          this.props.addNew != true &&
          (this.props.sampleData === undefined || this.props.sampleData === {})
        ) {
          this.getDataSourceSample(chartConfig.dataUrl);
          this.SetIsSummaryData(chartConfig.dataUrl);
        }
      }
    );
  }

  /**
   * call on trend change event
   * @param {*} value 
   * @param {*} key 
   */
  handleTrendChange = (value, key) => {
    const {configuration} = this.state;
    if (configuration.trend === undefined) {
      configuration.trend = { type: "", key: "" };
    }
    configuration.trend[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * call on extra parameter change
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   */
  handleExtraParameterChange = (value, key, index) => {
    const {configuration} = this.state;
    if (configuration.extraParameters === undefined) {
      configuration.extraParameters = [
        {
          parameterName: "",
          parameterValue: ""
        }
      ];
    }
    configuration.extraParameters[index][key] = value;
    this.setState({
      configuration: configuration
    });
  };

  /**
   * add extra parameter function
   */
  AddExtraParameter = () => {
    const {configuration} = this.state;
    if (configuration.extraParameters === undefined) {
      configuration.extraParameters = [
        {
          parameterName: "",
          parameterValue: ""
        }
      ];
    } else {
      configuration.extraParameters.push({
        parameterName: "",
        parameterValue: ""
      });
    }
    this.setState({
      configuration: configuration
    });
  };

  /**
   * handle change event
   * @param {*} value 
   * @param {*} key 
   */
  handleChange = (value, key) => {
    const {chartConfig} = this.state;
    chartConfig[key] = value;
    this.setState(
      {
        chartConfig: chartConfig
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * call on configuration change
   * @param {*} value 
   * @param {*} key 
   */
  handleConfigurationChange = (value, key) => {
    const {configuration} = this.state;

    configuration[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * call to handle auto generate column change
   * @param {*} value 
   * @param {*} key 
   */
  handleAutoGenerateColumnChange = (value, key) => {
    const {configuration} = this.state;

    if (configuration.autoGenerate === undefined) {
      configuration.autoGenerate = { key: "", filters: [] };
    }
    configuration.autoGenerate[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * handle calumn change event
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   */
  handleColumnChange = (value, key, index) => {
    const {configuration} = this.state;
    configuration.columns[index][key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * filter change handle event
   * @param {*} value 
   * @param {*} key 
   * @param {*} columnIndex 
   * @param {*} index 
   */
  handleFilterChange = (value, key, columnIndex, index) => {
    const {configuration} = this.state;
    if (columnIndex == "autoGenerate") {
      configuration.autoGenerate.filters[index][key] = value;
    } else {
      configuration.columns[columnIndex].filters[index][key] = value;
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * filter value change handle event
   * @param {*} value 
   * @param {*} columnIndex 
   * @param {*} index 
   */
  handleFilterValueChange = (value, columnIndex, index) => {
    const { configuration } = this.state;
    if (columnIndex == "autoGenerate") {
      configuration.autoGenerate.filters[index].values = value;
    } else {
      const flitters = configuration.columns[columnIndex].filters;
      flitters[index].values = value;
      configuration.columns[columnIndex].filters = flitters;
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * Function to add new column
   */
  addNewColumn = () => {
    const { configuration } = this.state;
    if (configuration.columns === undefined) {
      configuration.columns = [];
    }
    configuration.columns.push({
      key: "",
      name: "",
      type: "count",
      filters: [
        {
          key: "",
          values: []
        }
      ],
      color: "#E59400",
      sortOrder: 0
    });
    this.setState({
      configuration: configuration
    });
  };

  /**
   * Delete existing column
   * @param {*} index 
   */
  deleteColumn = index => {
    const {configuration} = this.state;

    configuration.columns.splice(index, 1);
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * Add new column filter.
   * @param {*} index 
   */
  addNewColumnFilter = index => {
    const {configuration} = this.state;

    if (index == "autoGenerate") {
      if (configuration.autoGenerate === undefined)
        configuration.autoGenerate = { key: "", filters: [] };
      configuration.autoGenerate.filters.push({
        key: "",
        values: []
      });
    } else {
      configuration.columns[index].filters.push({
        key: "",
        values: []
      });
    }
    this.setState({
      configuration: configuration
    });
  };

  /**
   * Delete filter
   * @param {*} columnIndex 
   * @param {*} filterIndex 
   */
  deleteFilter = (columnIndex, filterIndex) => {
    const {configuration} = this.state;

    if (columnIndex == "autoGenerate") {
      ((configuration.autoGenerate || {}).filters || []).splice(filterIndex, 1);
    } else {
      configuration.columns[columnIndex].filters.splice(filterIndex, 1);
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  /**
   * function for data source sample
   * @param {*} url 
   * @param {*} openViewSampleDataPanel 
   */
  getDataSourceSample = (url, openViewSampleDataPanel = false) => {
    //4 should be hardcoded
    this.GetData(
      2,
      moment()
        .subtract(6, "month")
        .format("MM/DD/yyyy"),
      moment().format("MM/DD/yyyy"),
      url,
      openViewSampleDataPanel
    );
  };

  /**
   * get data 
   * @param {*} propertyId 
   * @param {*} startDate 
   * @param {*} endDate 
   * @param {*} url 
   * @param {*} openViewSampleDataPanel 
   */
  GetData = (
    propertyId,
    startDate,
    endDate,
    url,
    openViewSampleDataPanel = false
  ) => {
    //let configuration = this.state.configuration;
    const params = {
      sourceName: url,
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };
    //console.log("Sending", params, widgetconfig);
    apiPost({
      url: API_URL.widget.GetWidgetSourceData,
      params: params,
      postBody: []
    }).then(({ data: response }) => {
      this.setState({
        sampleData: camelCaseKeys(response.data[0]),
        sampleViewData: camelCaseKeys(response.data.slice(0, 10)),
        openViewSampleDataPanel: openViewSampleDataPanel
        //configuration: configuration
      });
    });
  };

  /**
   * function to load performance attribute
   * @param {*} reportId 
   */
  loadPerformanceAttribute = reportId => {
    const params = {
      propertyId: 6,
      reportId: reportId
    };
    const { chartConfig } = this.state;
    chartConfig.reportId = reportId;
    apiRequest({
      url: API_URL.performance.GetPerformanceReportAttribute,
      params
    }).then(({ data: performanceReportAttribute }) => {
      let perfAttribute = [];
      perfAttribute = removeDuplicates(
        performanceReportAttribute
          .filter(function(x) {
            return x.isKeyAttribute == true;
          })
          .map(a => ({
            attributeName: a.attributeName,
            attributeListId: a.attributeListId
          })),
        "attributeListId"
      );

      this.setState({
        performanceReportAttribute: perfAttribute,
        chartConfig: chartConfig
        //configuration: configuration
      });
    });
  };

  /**
   * get master data
   */
  GetMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.widget.GetWidgetMasterDataList,
        key: "widgetMasterData"
      },
      {
        url: API_URL.widget.GetWidgetSourceList,
        key: "sourceList"
      },
      {
        url: API_URL.masterData.GetServiceLocations + "?propertyId=" + 6,
        key: "serviceLocationsList"
      },
      {
        url:
          API_URL.performance.GetPerformanceReportListByProperty +
          "?propertyId=6",
        key: "reportList"
      }
    ]).then(
      ({ widgetMasterData, sourceList, reportList }) => {
        this.setState(
          {
            masterData: widgetMasterData.data,
            sourceList: sourceList.data,
            reportList: reportList.data || []
          },
          () => this.SetIsSummaryData(this.state.chartConfig.dataUrl)
        );
      }
    );
  };

  /**
   * Get master data by key
   * @param {*} keyValue 
   * @returns 
   */
  GetMasterDataByKey = keyValue => {
    const { masterData } = this.state;
    // console.log(keyValue);
    return (masterData || []).filter(function(v) {
      return v.key.toLowerCase() == keyValue.toLowerCase();
    });
  };

  /**
   * handle preview click open
   */
  handlePreviewClickOpen = () => {
    const configuration = this.state.configuration;
    const chartConfig = this.state.chartConfig;
    if (this.isValidateConfiguration(true) == true) {
      chartConfig.configuration = JSON.stringify(
        configuration || this.state.masterConfig.configuration
      );
      this.setState({ openPreview: true, chartConfig: chartConfig });
    }
  };

  /**
   * handle preview close
   */
  handlePreviewClose = () => {
    this.setState({ openPreview: false });
  };

  /**
   * handle preview panel confirm open 
   */
  handleConfirmPreviewClickOpen = () => {
    this.setState({ openPreview: false, openConfirmPreview: true });
  };

  /**
   * handle preview panel confirm close
   */
  handleConfirmPreviewClose = () => {
    this.setState({ openConfirmPreview: false, openPreview: true });
  };

  /**
   * Function to handle sample data view close
   */
  handleSampleDataViewClose = () => {
    this.setState({ openViewSampleDataPanel: false });
  };

  /**
   * get input for keys
   * @param {*} key 
   * @param {*} columnIndex 
   * @param {*} filterIndex 
   * @param {*} values 
   * @returns 
   */
  getInputForKey = (key, columnIndex, filterIndex, values) => {
    const options = this.GetMasterDataByKey(key);

    if (options != undefined && options.length > 0) {
      const result = values.filter(function(v) {
        return options.find(value => value.label == v);
      });
      if (result == undefined || result.length == 0) {
        values = [];
      }
      return (
        <FormControl
          key={
            "FormControl_multiple-master-label" + columnIndex + "c" + filterIndex
          }
          style={{
            minWidth: 120,
            maxWidth: 300
          }}
          error={this.getFilterErrorStatus("key", filterIndex, columnIndex)}
        >
          <InputLabel
            error={this.getFilterErrorStatus("key", filterIndex, columnIndex)}
            helperText={
              this.getFilterErrorStatus("key", filterIndex, columnIndex) &&
              "Filter on values must be specified."
            }
            id={"multiple-master-label" + columnIndex + "c" + filterIndex}
          >
            {"Value(s)\r"}
          </InputLabel>
          <Select
            labelId={"multiple-master-label" + columnIndex + "c" + filterIndex}
            id={"multiple-master-select" + columnIndex + "c" + filterIndex}
            multiple
            defaultChecked={values}
            defaultValue={values}
            error={this.getFilterErrorStatus("key", filterIndex, columnIndex)}
            helperText={
              this.getFilterErrorStatus("key", filterIndex, columnIndex) &&
              "Filter on values must be specified."
            }
            onChange={event => {
              this.handleFilterValueChange(
                event.target.value,
                columnIndex,
                filterIndex
              );
            }}
            input={
              <Input
                key={
                  "multiple-master-chipInput" + columnIndex + "c" + filterIndex
                }
                id={
                  "multiple-master-chipInput" + columnIndex + "c" + filterIndex
                }
              />
            }
            renderValue={selected => (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap"
                }}
              >
                {selected.map(value => (
                  <Chip
                    key={"chip" + columnIndex + "c" + filterIndex}
                    label={value}
                    style={{ margin: 2 }}
                  />
                ))}
              </div>
            )}
            MenuProps={MenuProps}
          >
            {options.map((data, ic) => (
              <MenuItem
                key={"masterOption" + columnIndex + "c" + filterIndex + ic}
                value={data.label}
              >
                {data.label}
              </MenuItem>
            ))}
          </Select>
          {this.getFilterErrorStatus("key", filterIndex, columnIndex) && (
            <FormHelperText>{"Filter on values must be specified."}</FormHelperText>
          )}
        </FormControl>
      );
    }

    return (
      <ChipInput
        key={ChipInput + columnIndex + "c" + filterIndex}
        id={ChipInput + columnIndex + "c" + filterIndex}
        label={"Value(s)"}
        defaultValue={values}
        error={this.getFilterErrorStatus("key", filterIndex, columnIndex)}
        helperText={
          this.getFilterErrorStatus("key", filterIndex, columnIndex) &&
          "Filter on values must be specified."
        }
        onChange={chips => {
          this.handleFilterValueChange([...chips], columnIndex, filterIndex);
        }}
      />
    );
  };

  /**
   * function to set summery data as per values
   * @param {*} value 
   */
  SetIsSummaryData = value => {
    const { sourceList, chartConfig } = this.state;
    const source = (sourceList || []).find(
      x =>
        x.sourceName == value &&
        (x.isSummaryData == true || x.isPerformanceData == true)
    );
    let isSummaryData = false;
    let isForPerformance = false;
    if (source != undefined) {
      if (source.isSummaryData == true) isSummaryData = true;
      if (source.isPerformanceData == true) isForPerformance = true;
      chartConfig.isForPerformance = isForPerformance;
    }
    if (isForPerformance == false) {
      this.getDataSourceSample(value);
    }
    this.setState({
      isSummaryData: isSummaryData,
      isForPerformance: isForPerformance,
      chartConfig: chartConfig
    });
  };

  /**
   * function to validate configurations
   */
  isValidateConfiguration = showToast => {
    const {
      isForPerformance,
      chartConfig,
      configuration
    } = this.state;
    const errors = { fields: [], columns: [], filters: [] };
    // console.log(chartConfig);
    const message = [];
    if (this.props.configureMaster == true) {
      if ((chartConfig.name || "") == "") {
        message.push(<li>{"Please enter widget name."}</li>);
        errors.fields.push("name");
      }
    } else {
      if ((chartConfig.title || "") == "") {
        message.push(<li>{"Please enter widget title. "}</li>);
        errors.fields.push("title");
      }
    }
    if (this.props.configureMaster == true) {
      if (
        (chartConfig.minWidth || 0) == 0 ||
        (chartConfig.minHeight || 0) == 0 ||
        (chartConfig.minWidth || 0) > 12 ||
        (chartConfig.minHeight || 0) > 12
      ) {
        message.push(<li>{"Please enter valid width and height."}</li>);
        if (
          (chartConfig.minWidth || 0) == 0 ||
          (chartConfig.minWidth || 0) > 12
        ) {
          errors.fields.push("minWidth");
        }
        if (
          (chartConfig.minHeight || 0) == 0 ||
          (chartConfig.minHeight || 0) > 12
        ) {
          errors.fields.push("minHeight");
        }
      }
    } else {
      if (
        (chartConfig.width || 0) == 0 ||
        (chartConfig.height || 0) == 0 ||
        (chartConfig.width || 0) > 12 ||
        (chartConfig.height || 0) > 12
      ) {
        message.push(<li>{"Please enter valid width and height."}</li>);
        if ((chartConfig.width || 0) == 0 || (chartConfig.width || 0) > 12) {
          errors.fields.push("width");
        }
        if ((chartConfig.height || 0) == 0 || (chartConfig.height || 0) > 12) {
          errors.fields.push("height");
        }
      }
    }
    if (this.props.configureMaster == true) {
      if ((chartConfig.dataUrl || "") == "") {
        message.push(<li>{"Please select data source."}</li>);
        errors.fields.push("dataUrl");
      }
    }

    if ((chartConfig.widgetType || "") == "") {
      message.push(<li>{"Please select widget type."}</li>);
      errors.fields.push("widgetType");
    } else {
      if (chartConfig.widgetType > 3 && isForPerformance == false) {
        if (
          configuration.trend == undefined ||
          (configuration.trend.key || "") == ""
        ) {
          message.push(<li>{"Please select trend on field."}</li>);
          errors.fields.push("trend");
        }
      }
    }

    if (isForPerformance == true) {
      if (chartConfig.reportId == undefined || configuration.reportId == 0) {
        message.push(<li>{"Please select performance view."}</li>);
        errors.fields.push("reportId");
      }
      if (
        chartConfig.attributeId == undefined ||
        configuration.attributeId == 0
      ) {
        message.push(<li>{"Please select performance view attribute."}</li>);
        errors.fields.push("attributeListId");
      }
    }

    if (chartConfig.isConfigurable == true || chartConfig.widgetType == 3) {
      if (configuration.isRepeated == true) {
        if (
          configuration.autoGenerate == undefined ||
          configuration.autoGenerate.key == ""
        ) {
          message.push(<li>{"Please select field for auto generate column."}</li>);
          errors.fields.push("autoGenerate");
        }
      } else {
        if (
          configuration.columns == undefined ||
          configuration.columns.length == 0
        ) {
          message.push(<li>{"Please add column(s)."}</li>);
        } else {
          let isInvalidColumn = false;
          let isInvalidFilter = false;
          const columnLength = configuration.columns.length;
          const sortIndex = [];
          configuration.columns.map((col, index) => {
            if (((col.key || "") == "") & (col.type == "Individual")) {
              isInvalidColumn = true;
              errors.columns.push({ key: "key", index: index });
            }
            if ((col.name || "") == "") {
              isInvalidColumn = true;
              errors.columns.push({ key: "name", index: index });
            }
            if (chartConfig.widgetType != 3) {
              if (col.sortOrder > columnLength) {
                isInvalidColumn = true;
                errors.columns.push({ key: "sortOrder", index: index });
              } else {
                if (sortIndex.find(x => x == col.sortOrder) != undefined) {
                  isInvalidColumn = true;
                  errors.columns.push({ key: "sortOrder", index: index });
                } else {
                  sortIndex.push(col.sortOrder);
                }
              }
            }
            if (chartConfig.widgetType > 3) {
              (col.filters || []).map((fl, i) => {
                if ((fl.key || "") == "" || (fl.values || []).length == 0) {
                  isInvalidFilter = true;
                  if ((fl.key || "") == "") {
                    errors.filters.push({
                      key: "key",
                      index: i,
                      columnIndex: index
                    });
                  }
                  if ((fl.values || []).length == 0) {
                    errors.filters.push({
                      key: "values",
                      index: i,
                      columnIndex: index
                    });
                  }
                }
              });
            }
          });
          if (isInvalidColumn) {
            message.push(<li>{"Invalid column(s) configuration."}</li>);
          }
          if (isInvalidFilter) {
            message.push(<li>{"Invalid filters(s) configuration."}</li>);
          }
        }
      }
    }
    if (message.length > 0) {
      this.setState(
        { errors: errors },
        () => showToast && ShowToast(message, toastType.ERROR, 5000, 500)
      );
      return false;
    } else {
      this.setState({ errors: { fields: [], columns: [], filters: [] } });
      return true;
    }
  };

  /**
   * get error status
   * @param {*} key 
   * @returns 
   */
  getErrorStatus = key => {
    const { errors } = this.state;
    const isFound = errors.fields.find(x => x == key);
    if (isFound != undefined) {
      return true;
    }
    return false;
  };

  /**
   * get column error status
   * @param {*} key 
   * @param {*} index 
   * @returns 
   */
  getColumnErrorStatus = (key, index) => {
    const { errors } = this.state;
    const isFound = errors.columns.find(x => x.key == key && x.index == index);
    if (isFound != undefined) {
      return true;
    }
    return false;
  };

  /**
   * get filter error status
   * @param {*} key 
   * @param {*} index 
   * @param {*} columnIndex 
   * @returns 
   */
  getFilterErrorStatus = (key, index, columnIndex) => {
    const { errors } = this.state;
    const isFound = errors.filters.find(
      x => x.key == key && x.index == index && x.columnIndex == columnIndex
    );
    if (isFound != undefined) {
      return true;
    }
    return false;
  };

  /**
   * function to show data source sample
   * @param {*} dataUrl 
   */
  ShowDataSourceSample = dataUrl => {
    const { sampleViewData } = this.state;
    if (sampleViewData == undefined) {
      this.getDataSourceSample(dataUrl, true);
    } else {
      this.setState({ openViewSampleDataPanel: true });
    }
  };
 
  

  render() {
    const {
      masterConfig,
      chartConfig,
      sampleData,
      configuration,
      openPreview,
      sampleViewData,
      openConfirmPreview,
      openViewSampleDataPanel,
      param,
      sourceList,
      isSummaryData,
      isForPerformance,
      reportList,
      performanceReportAttribute
    } = this.state;
    return (
      <div className={"configure-widget"}>
        {" "}
        {masterConfig && chartConfig && (
          <>
            {this.props.configureMaster != true && (
              <div className={"col-lg-12 "}>
                <div className={"widgetIcon col-lg-4"} />
                <div className={"widgetIcon col-lg-8"}>
                  <h1>{masterConfig.name}</h1>
                  <span>{"Type: "}{masterConfig.type}</span>
                  <p>{masterConfig.description}</p>
                </div>
              </div>
            )}
            <div className={"widget-holder col-lg-11"}>
              <form noValidate autoComplete={"off"}>
                <div className={"row"}>
                  <fieldset className={"col-lg-12"}>
                    <legend>{"General"}</legend>
                    <div className={"row"}>
                      <div className={"col-lg-12"}>
                        {this.props.configureMaster != true && (
                          <TextField
                            size={"small"}
                            id={"title"}
                            error={this.getErrorStatus("title")}
                            helperText={
                              this.getErrorStatus("title") &&
                              "Title is mandatory"
                            }
                            defaultValue={
                              chartConfig.title || masterConfig.name
                            }
                            onChange={event => {
                              this.handleChange(event.target.value, "title");
                            }}
                            label={"Override Title"}
                          />
                        )}
                        {this.props.configureMaster == true && (
                          <TextField
                            size={"small"}
                            id={"title"}
                            defaultValue={chartConfig.name}
                            onChange={event => {
                              this.handleChange(event.target.value, "name");
                            }}
                            error={this.getErrorStatus("name")}
                            helperText={
                              this.getErrorStatus("name") && "Name is mandatory"
                            }
                            label={"Widget Name"}
                          />
                        )}
                      </div>

                      {this.props.configureMaster != true && (
                        <>
                          {" "}
                          <div className={"col-lg-6"}>
                            <TextField
                              size={"small"}
                              id={"Width"}
                              defaultValue={
                                chartConfig.width || masterConfig.minWidth
                              }
                              onChange={event => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  "width"
                                );
                              }}
                              label={"Width"}
                              error={this.getErrorStatus("width")}
                              helperText={
                                this.getErrorStatus("width") &&
                                "Width is mandatory. Value must be between 1-12"
                              }
                            />
                          </div>
                          <div className={"col-lg-6"}>
                            <TextField
                              size={"small"}
                              id={"Height"}
                              defaultValue={
                                chartConfig.height || masterConfig.minHeight
                              }
                              onChange={event => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  "height"
                                );
                              }}
                              label={"Height"}
                              error={this.getErrorStatus("height")}
                              helperText={
                                this.getErrorStatus("height") &&
                                "Height is mandatory. Value must be between 1-12"
                              }
                            />
                          </div>
                        </>
                      )}
                      {this.props.configureMaster == true && (
                        <>
                          <div className={"col-lg-6"}>
                            <TextField
                              size={"small"}
                              id={"MinWidth"}
                              value={chartConfig.minWidth}
                              onChange={event => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  "minWidth"
                                );
                              }}
                              label={"Minimum Width"}
                              error={this.getErrorStatus("minWidth")}
                              helperText={
                                this.getErrorStatus("minWidth") &&
                                "Minimum width is required. Value must be between 1-12"
                              }
                            />
                          </div>
                          <div className={"col-lg-6"}>
                            <TextField
                              size={"small"}
                              id={"MinHeight"}
                              value={chartConfig.minHeight}
                              onChange={event => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  "minHeight"
                                );
                              }}
                              label={"Minimum Height"}
                              error={this.getErrorStatus("minHeight")}
                              helperText={
                                this.getErrorStatus("minHeight") &&
                                "Minimum Height is required. Value must be between 1-12"
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </fieldset>
                  <fieldset className={"col-lg-12"}>
                    <legend>
                      {"Data Source & type\r"}
                      {isForPerformance != true && (
                        <>
                          <Tooltip title={"View Sample Data"}>
                            <IconButton
                              aria-label={"refreshData"}
                              size={"small"}
                              onClick={() => {
                                this.ShowDataSourceSample(chartConfig.dataUrl);
                              }}
                            >
                              <Visibility fontSize={"small"} size={"small"} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Refresh Data Source"}>
                            <IconButton
                              aria-label={"refreshData"}
                              size={"small"}
                              onClick={() => {
                                this.getDataSourceSample(chartConfig.dataUrl);
                              }}
                            >
                              <RefreshOutlined fontSize={"small"} size={"small"} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}{" "}
                    </legend>
                    <div className={"row"}>
                      <div className={"col-lg-6"}>
                        {/* <TextField size="small" id="dataSource" value={masterConfig.dataUrl} label="Data source" /> */}
                        <FormControl
                          size={"small"}
                          error={this.getErrorStatus("dataUrl")}
                        >
                          <InputLabel size={"small"} id={"WidgetDataSourceLabel"}>
                            {"Type\r"}
                          </InputLabel>
                          <Select
                            size={"small"}
                            disabled={!this.props.configureMaster}
                            labelId={"WidgetDataSourceLabel"}
                            id={"WidgetDataSourceSelect"}
                            defaultValue={chartConfig.dataUrl}
                            error={this.getErrorStatus("dataUrl")}
                            helperText={
                              this.getErrorStatus("dataUrl") &&
                              "Data source is required."
                            }
                            onChange={event => {
                              this.handleChange(event.target.value, "dataUrl");
                              this.SetIsSummaryData(event.target.value);

                              this.getDataSourceSample(event.target.value);
                            }}
                          >
                            {sourceList &&
                              sourceList.map((key, ic) => {
                                return (
                                  <MenuItem
                                    size={"small"}
                                    key={"SourceName" + ic}
                                    title={key.description}
                                    value={key.sourceName}
                                  >
                                    {key.sourceName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          {this.getErrorStatus("dataUrl") && (
                            <FormHelperText>
                              {"Data source is required.\r"}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                      <div className={"col-lg-6"}>
                        <FormControl
                          size={"small"}
                          error={this.getErrorStatus("widgetType")}
                        >
                          <InputLabel size={"small"} id={"WidgetTypeLabelKey"}>
                            {"Type\r"}
                          </InputLabel>
                          <Select
                            size={"small"}
                            labelId={"WidgetTypeLabelKey"}
                            id={"WidgetTypeLabelKeySelect"}
                            defaultValue={chartConfig.widgetType}
                            error={this.getErrorStatus("widgetType")}
                            helperText={
                              this.getErrorStatus("widgetType") &&
                              "Widget Type is required."
                            }
                            onChange={event => {
                              this.handleChange(
                                event.target.value,
                                "widgetType"
                              );
                              if (event.target.value == 3) {
                                this.handleConfigurationChange(
                                  false,
                                  "isRepeated"
                                );
                              }
                              if (
                                event.target.value > 3 &&
                                isForPerformance == false
                              ) {
                                this.handleChange(true, "isConfigurable");
                              }
                            }}
                          >
                            {isForPerformance != true && (
                              <MenuItem size={"small"} value={1}>
                                {"In Line Form"}{" "}
                              </MenuItem>
                            )}
                            {isForPerformance != true && (
                              <MenuItem size={"small"} value={2}>
                                {"Key Value Form\r"}
                              </MenuItem>
                            )}
                            {isForPerformance != true && (
                              <MenuItem size={"small"} value={3}>
                                {"Table\r"}
                              </MenuItem>
                            )}
                            {isSummaryData == false && (
                              <MenuItem size={"small"} value={4}>
                                {"Multiline Chart\r"}
                              </MenuItem>
                            )}
                            {isForPerformance != true &&
                              isSummaryData == false && (
                                <MenuItem size={"small"} value={5}>
                                  {"Bar Chart\r"}
                                </MenuItem>
                              )}
                            {isForPerformance != true &&
                              isSummaryData == false && (
                                <MenuItem size={"small"} value={6}>
                                  {"Donut Chart\r"}
                                </MenuItem>
                              )}
                            {isForPerformance != true &&
                              isSummaryData == false && (
                                <MenuItem size={"small"} value={7}>
                                  {"Pie Chart\r"}
                                </MenuItem>
                              )}
                            {isSummaryData == false && (
                              <MenuItem size={"small"} value={8}>
                                {"Stack Bar Chart\r"}
                              </MenuItem>
                            )}
                            {isSummaryData == false && (
                              <MenuItem size={"small"} value={9}>
                                {"Group Bar Chart\r"}
                              </MenuItem>
                            )}
                            {/* <MenuItem size="small" value={10}>Map</MenuItem> */}
                          </Select>
                          {this.getErrorStatus("widgetType") && (
                            <FormHelperText>
                              {"Widget Type is required.\r"}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                    </div>
                    {(chartConfig.widgetType === 5 ||
                      chartConfig.widgetType === 4 ||
                      chartConfig.widgetType === 8 ||
                      chartConfig.widgetType === 9) && (
                      <div className={"row"}>
                        <div className={"col-lg-6"}>
                          <TextField
                            size={"small"}
                            id={"dataSource"}
                            value={configuration.yAxisLabel}
                            onChange={event => {
                              this.handleConfigurationChange(
                                event.target.value,
                                "yAxisLabel"
                              );
                            }}
                            label={"Y Axis Label"}
                          />
                        </div>
                      </div>
                    )}
                  </fieldset>

                  {chartConfig.widgetType != 3 &&
                    isSummaryData == false &&
                    isForPerformance != true && (
                      <fieldset className={"col-lg-12"}>
                        <legend>{"Trend"}</legend>
                        <div className={"row"}>
                          <div className={"col-lg-6"}>
                            <FormControl
                              size={"small"}
                              error={this.getErrorStatus("trend")}
                            >
                              <InputLabel
                                size={"small"}
                                id={"columnTrendKeyLabel"}
                              >
                                {"on Field\r"}
                              </InputLabel>
                              <Select
                                required
                                //error={((configuration.trend || {}).key||"")==""?true:false}
                                size={"small"}
                                labelId={"columnTrendKeyLabel"}
                                id={"columnKeySelect"}
                                error={this.getErrorStatus("trend")}
                                helperText={
                                  this.getErrorStatus("trend") &&
                                  "Trend on field is required."
                                }
                                defaultValue={(configuration.trend || {}).key}
                                onChange={event => {
                                  this.handleTrendChange(
                                    event.target.value,
                                    "key"
                                  );
                                }}
                              >
                                <MenuItem value={""}>
                                  <em>{"None"}</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size={"small"}
                                        key={"trendKey" + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus("trend") && (
                                <FormHelperText>
                                  {"Trend on field is required.\r"}
                                </FormHelperText>
                              )}
                              <FormHelperText>
                                {"**Selected field should be of type Date\r"}
                              </FormHelperText>
                            </FormControl>
                          </div>
                          <div className={"col-lg-6"}>
                          <FormControlLabel
                            id={"trendOnPastDateLabel"}
                            key={"trendOnPastDateLabelKey"}
                            value={configuration.trendOnPastDate || false}
                            checked={configuration.trendOnPastDate || false}
                            control={
                              <Checkbox
                                id={"trendOnPastDaCheckbox"}
                                key={"trendOnPastDateCheckbox"}
                                checked={configuration.trendOnPastDate || false}
                                color={"primary"}
                                onChange={event => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    "trendOnPastDate"
                                  );
                                }}
                              />
                            }
                            label={"Trend On Past Date"}
                            labelPlacement={"end"}
                          />
                          </div>
                        </div>
                      </fieldset>
                    )}
                    <div className={"col-lg-12"}>
                          <FormControlLabel
                            id={"stopDrillDownCheckboxLabel"}
                            key={"stopDrillDownCheckboxLabelKey"}
                            value={configuration?.stopDrillDown || false}
                            checked={configuration?.stopDrillDown || false}
                            control={
                              <Checkbox
                                id={"stopDrillDownCheckbox"}
                                key={"stopDrillDownCheckbox"}
                                checked={configuration?.stopDrillDown || false}
                                color={"primary"}
                                onChange={event => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    "stopDrillDown"
                                  );
                                }}
                              />
                            }
                            label={"Stop DrillDown"}
                            labelPlacement={"end"}
                          />
                    </div>
                    
                  {this.props.configureMaster == true &&
                    isForPerformance == false &&
                    (isSummaryData == false || chartConfig.widgetType == 3) && (
                      <>
                        <div className={"col-lg-12"}>
                          <FormControlLabel
                            id={"isConfigurableControlLabel"}
                            key={"isConfigurableControlLabelKey"}
                            value={chartConfig.isConfigurable || false}
                            checked={chartConfig.isConfigurable}
                            control={
                              <Checkbox
                                id={"isConfigurableCheckbox"}
                                key={"isConfigurableCheckbox"}
                                checked={chartConfig.isConfigurable}
                                color={"primary"}
                                onChange={event => {
                                  this.handleChange(
                                    event.target.checked,
                                    "isConfigurable"
                                  );
                                }}
                              />
                            }
                            label={"Is Configurable"}
                            labelPlacement={"end"}
                          />
                        </div>
                      </>
                    )}
                  {chartConfig.isForPerformance == true && (
                    <>
                      <fieldset className={"col-lg-12"}>
                        <legend>{"Performance View"}</legend>
                        <div className={"row"}>
                          <div className={"col-lg-6"}>
                            <FormControl
                              size={"small"}
                              error={this.getErrorStatus("reportId")}
                            >
                              <InputLabel
                                size={"small"}
                                id={"columnReportIdKeyLabel"}
                              >
                                {"View Name\r"}
                              </InputLabel>
                              <Select
                                required
                                size={"small"}
                                labelId={"columnReportIdKeyLabel"}
                                id={"columnReportIdKeySelect"}
                                error={this.getErrorStatus("reportId")}
                                helperText={
                                  this.getErrorStatus("reportId") &&
                                  "Performance view is required."
                                }
                                defaultValue={chartConfig.reportId || 0}
                                onChange={event => {
                                  this.loadPerformanceAttribute(
                                    event.target.value
                                  );
                                }}
                              >
                                <MenuItem value={0}>
                                  <em>{"None"}</em>
                                </MenuItem>
                                {reportList &&
                                  reportList.map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size={"small"}
                                        key={"trendKey" + ic}
                                        value={key.reportId}
                                      >
                                        {key.reportName}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus("reportId") && (
                                <FormHelperText>
                                  {"Performance View is required.\r"}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div className={"col-lg-6"}>
                            <FormControl
                              size={"small"}
                              error={this.getErrorStatus("attributeId")}
                            >
                              <InputLabel
                                size={"small"}
                                id={"columnReportAttributeKeyLabel"}
                              >
                                {"View Attribute\r"}
                              </InputLabel>
                              <Select
                                required
                                size={"small"}
                                labelId={"columnReportAttributeKeyLabel"}
                                id={"columnReportAttributeKeySelect"}
                                error={this.getErrorStatus("attributeId")}
                                helperText={
                                  this.getErrorStatus("attributeId") &&
                                  "Attribute is required."
                                }
                                value={chartConfig.attributeId || 0}
                                onChange={event => {
                                  this.handleChange(
                                    event.target.value,
                                    "attributeId"
                                  );
                                }}
                              >
                                <MenuItem value={0}>
                                  <em>{"None"}</em>
                                </MenuItem>
                                {performanceReportAttribute &&
                                  performanceReportAttribute.map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size={"small"}
                                        key={"trendKey" + ic}
                                        value={key.attributeListId}
                                      >
                                        {key.attributeName}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus("attributeId") && (
                                <FormHelperText>
                                  {"Attribute is required.\r"}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                        </div>
                      </fieldset>
                    </>
                  )}
                  {chartConfig.isConfigurable == true &&
                    isForPerformance == false && (
                      <>
                        {chartConfig.widgetType != 3 && (
                          <div className={"col-lg-12"}>
                            <FormControlLabel
                              id={"RepeatFormControlLabel"}
                              key={"RepeatFormControlLabelKey"}
                              value={configuration.isRepeated || false}
                              checked={configuration.isRepeated}
                              control={
                                <Checkbox
                                  id={"RepeatCheckbox"}
                                  checked={configuration.isRepeated}
                                  color={"primary"}
                                  onChange={event => {
                                    this.handleConfigurationChange(
                                      event.target.checked,
                                      "isRepeated"
                                    );
                                  }}
                                />
                              }
                              label={"Auto Generate columns Group By Field value"}
                              labelPlacement={"end"}
                            />
                          </div>
                        )}
                        {configuration.isRepeated === true &&
                          isForPerformance == false && (
                            <fieldset className={"col-lg-12"}>
                              <legend>{"Columns (Auto)"}</legend>

                              <div className={"row col-lg-12"}>
                                <div className={"col-lg-12"}>
                                  <FormControl
                                    size={"small"}
                                    error={this.getErrorStatus("autoGenerate")}
                                  >
                                    <InputLabel
                                      size={"small"}
                                      id={"autoGenerateColumnKeyLabel"}
                                    >
                                      {"Field\r"}
                                    </InputLabel>
                                    <Select
                                      size={"small"}
                                      labelId={"autoGenerateColumnKeyLabel"}
                                      id={"autoGenerateColumnKeySelect"}
                                      value={
                                        (configuration.autoGenerate || {}).key
                                      }
                                      error={this.getErrorStatus(
                                        "autoGenerate"
                                      )}
                                      helperText={
                                        this.getErrorStatus("autoGenerate") &&
                                        "AutoGenerate on field is required."
                                      }
                                      onChange={event => {
                                        this.handleAutoGenerateColumnChange(
                                          event.target.value,
                                          "key"
                                        );
                                      }}
                                    >
                                      <MenuItem value={""}>
                                        <em>{"None"}</em>
                                      </MenuItem>
                                      {sampleData &&
                                        Object.keys(sampleData).map(
                                          (key, index) => {
                                            return (
                                              <MenuItem
                                                key={"AutoKeyFieldkey" + index}
                                                size={"small"}
                                                value={key}
                                              >
                                                {key}
                                              </MenuItem>
                                            );
                                          }
                                        )}
                                    </Select>
                                    {this.getErrorStatus("autoGenerate") && (
                                      <FormHelperText>
                                        {"AutoGenerate on field is required.\r"}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </div>

                                <fieldset className={"col-lg-12"}>
                                  <legend>
                                    {"Apply Filter\r"}
                                    <Tooltip title={"Add New Filter"}>
                                      <IconButton
                                        aria-label={"autoGenerateFilter"}
                                        size={"small"}
                                        onClick={() =>
                                          this.addNewColumnFilter(
                                            "autoGenerate"
                                          )}
                                      >
                                        <AddCircleOutline fontSize={"small"} />
                                      </IconButton>
                                    </Tooltip>
                                  </legend>
                                  {(
                                    (configuration.autoGenerate || {})
                                      .filters || []
                                  ).map((filter, filterIndex) => {
                                    return (
                                      <>
                                        <div className={"row"}>
                                          <div className={"col-lg-1 no-padding"}>
                                            <Tooltip title={"Remove Filter"}>
                                              <IconButton
                                                aria-label={
                                                  "autoGenerateDeleteFilter" +
                                                  filterIndex
                                                }
                                                size={"small"}
                                                onClick={() =>
                                                  this.deleteFilter(
                                                    "autoGenerate",
                                                    filterIndex
                                                  )}
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      "var(--common--Text--color)"
                                                  }}
                                                  fontSize={"small"}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                          <div className={"col-lg-5"}>
                                            <FormControl size={"small"} required>
                                              <InputLabel
                                                size={"small"}
                                                id={
                                                  "autoGenerateFilterKeyLabel" +
                                                  filterIndex
                                                }
                                              >
                                                {"On\r"}
                                              </InputLabel>
                                              <Select
                                                size={"small"}
                                                required
                                                labelId={
                                                  "autoGenerateFilterKeyLabel" +
                                                  filterIndex
                                                }
                                                id={
                                                  "autoGenerateFilterKeySelect" +
                                                  filterIndex
                                                }
                                                value={filter.key}
                                                onChange={event => {
                                                  this.handleFilterChange(
                                                    event.target.value,
                                                    "key",
                                                    "autoGenerate",
                                                    filterIndex
                                                  );
                                                }}
                                              >
                                                <MenuItem value={""}>
                                                  <em>{"None"}</em>
                                                </MenuItem>
                                                {sampleData &&
                                                  Object.keys(sampleData).map(
                                                    key => {
                                                      return (
                                                        <MenuItem
                                                          size={"small"}
                                                          value={key}
                                                        >
                                                          {key}
                                                        </MenuItem>
                                                      );
                                                    }
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </div>
                                          <div className={"col-lg-6"}>
                                            {this.getInputForKey(
                                              filter.key,
                                              "autoGenerate",
                                              filterIndex,
                                              filter.values
                                            )}
                                            {/* <ChipInput
                                                                                label='Filter On'
                                                                                defaultValue={filter.values} 
                                                                                onChange={(chips) => this.handleFilterChange(chips, "key", columnIndex, filterIndex)}
                                                                            /> */}
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}
                                </fieldset>
                              </div>
                            </fieldset>
                          )}
                        {!configuration.isRepeated &&
                          isForPerformance == false && (
                            <fieldset className={"col-lg-12"}>
                              <legend>
                                {"Columns\r"}
                                <Tooltip title={"Add New Column"}>
                                  <IconButton
                                    aria-label={"addColumn"}
                                    size={"small"}
                                    onClick={this.addNewColumn}
                                  >
                                    <AddCircleOutline fontSize={"small"} />
                                  </IconButton>
                                </Tooltip>
                              </legend>

                              {configuration.columns &&
                                configuration.columns.map((column, index) => {
                                  const columnIndex = index;
                                  return (
                                    <>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={
                                            "Column-content" + index
                                          }
                                          id={"panel-header" + index}
                                        >
                                          <Typography>
                                            <Tooltip title={"Delete"}>
                                              <IconButton
                                                aria-label={
                                                  "delete" + columnIndex
                                                }
                                                size={"small"}
                                                onClick={() =>
                                                  this.deleteColumn(columnIndex)}
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      "var(--common--Text--color)"
                                                  }}
                                                  fontSize={"small"}
                                                />
                                              </IconButton>
                                            </Tooltip>{" "}
                                            &nbsp;{"Column "}{index + 1}
                                          </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <div className={"row col-lg-12"}>
                                            {chartConfig.widgetType != 3 && (
                                              <div className={"col-lg-6"}>
                                                <FormControl size={"small"}>
                                                  <InputLabel
                                                    size={"small"}
                                                    id={
                                                      "columnTypeLabelKey" + index
                                                    }
                                                  >
                                                    {"Type\r"}
                                                  </InputLabel>
                                                  <Select
                                                    size={"small"}
                                                    labelId={
                                                      "columnTypeLabelKey" + index
                                                    }
                                                    id={
                                                      "columnTypeSelect" + index
                                                    }
                                                    defaultValue={column.type}
                                                    value={column.type}
                                                    onChange={event => {
                                                      this.handleColumnChange(
                                                        event.target.value,
                                                        "type",
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <MenuItem
                                                      size={"small"}
                                                      value={"count"}
                                                    >
                                                      {"Count\r"}
                                                    </MenuItem>
                                                    <MenuItem
                                                      size={"small"}
                                                      value={"Individual"}
                                                    >
                                                      {"Individual\r"}
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                            )}
                                            <div className={"col-lg-6"}>
                                              <FormControl
                                                size={"small"}
                                                error={this.getColumnErrorStatus(
                                                  "key",
                                                  index
                                                )}
                                              >
                                                <InputLabel
                                                  size={"small"}
                                                  id={"columnKeyLabel" + index}
                                                >
                                                  {"Field\r"}
                                                </InputLabel>
                                                <Select
                                                  size={"small"}
                                                  labelId={
                                                    "columnKeyLabel" + index
                                                  }
                                                  id={"columnKeySelect" + index}
                                                  defaultValue={column.key}
                                                  value={column.key}
                                                  error={this.getColumnErrorStatus(
                                                    "key",
                                                    index
                                                  )}
                                                  helperText={
                                                    this.getColumnErrorStatus(
                                                      "key",
                                                      index
                                                    ) &&
                                                    "Column field must be selected."
                                                  }
                                                  onChange={event => {
                                                    this.handleColumnChange(
                                                      event.target.value,
                                                      "key",
                                                      index
                                                    );
                                                  }}
                                                >
                                                  <MenuItem value={""}>
                                                    <em>{"None"}</em>
                                                  </MenuItem>
                                                  {sampleData &&
                                                    Object.keys(sampleData).map(
                                                      (key, index) => {
                                                        return (
                                                          <MenuItem
                                                            key={"sampleMenu"+index}
                                                            size={"small"}
                                                            value={key}
                                                          >
                                                            {key}
                                                          </MenuItem>
                                                        );
                                                      }
                                                    )}
                                                </Select>
                                                {this.getColumnErrorStatus(
                                                  "key",
                                                  index
                                                ) && (
                                                  <FormHelperText>
                                                    {"Column field must be\r"}
                                                    {"selected.\r"}
                                                  </FormHelperText>
                                                )}
                                              </FormControl>
                                            </div>
                                            <div className={"col-lg-6"}>
                                              <TextField
                                                size={"small"}
                                                id={"name" + index}
                                                defaultValue={column.name}
                                                value={column.name}
                                                error={this.getColumnErrorStatus(
                                                  "name",
                                                  index
                                                )}
                                                helperText={
                                                  this.getColumnErrorStatus(
                                                    "name",
                                                    index
                                                  ) &&
                                                  "Column name must be specified."
                                                }
                                                onChange={event => {
                                                  this.handleColumnChange(
                                                    event.target.value,
                                                    "name",
                                                    index
                                                  );
                                                }}
                                                label={"Display Name"}
                                              />
                                            </div>

                                            {chartConfig.widgetType != 3 && (
                                              <>
                                                {" "}
                                                <div
                                                  className={"col-lg-3"}
                                                  style={{
                                                    backgroundColor:
                                                      column.color
                                                  }}
                                                >
                                                  <ColorPicker
                                                    key={"color" + index}
                                                    id={"color" + index}
                                                    name={"color"}
                                                    label={"Color"}
                                                    value={
                                                      column.color ||
                                                      colors[index]
                                                    }
                                                    //value={column.color} //- for controlled component
                                                    //onChange={color => console.log(color)}
                                                    onChange={color =>
                                                      this.handleColumnChange(
                                                        color,
                                                        "color",
                                                        index
                                                      )}
                                                  />
                                                </div>
                                                <div className={"col-lg-3"}>
                                                  <TextField
                                                    size={"small"}
                                                    id={"sortOrder" + index}
                                                    defaultValue={
                                                      column.sortOrder
                                                    }
                                                    error={this.getColumnErrorStatus(
                                                      "sortOrder",
                                                      index
                                                    )}
                                                    type={"number"}
                                                    helperText={
                                                      this.getColumnErrorStatus(
                                                        "sortOrder",
                                                        index
                                                      ) && "Invalid sort order."
                                                    }
                                                    onChange={event => {
                                                      this.handleColumnChange(
                                                        event.target.value,
                                                        "sortOrder",
                                                        index
                                                      );
                                                    }}
                                                    label={"Sort Order"}
                                                  />
                                                </div>
                                              </>
                                            )}
                                            {chartConfig.widgetType != 3 &&
                                              column.type == "count" && (
                                                <fieldset className={"col-lg-12"}>
                                                  <legend>
                                                    {"Apply Filter\r"}
                                                    <Tooltip title={"Add New Filter"}>
                                                      <IconButton
                                                        aria-label={
                                                          "filter" + columnIndex
                                                        }
                                                        size={"small"}
                                                        onClick={() =>
                                                          this.addNewColumnFilter(
                                                            columnIndex
                                                          )}
                                                      >
                                                        <AddCircleOutline fontSize={"small"} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  </legend>
                                                  {column.filters.map(
                                                    (filter, filterIndex) => {
                                                      return (
                                                        <>
                                                          <div className={"row"}>
                                                            <div className={"col-lg-1 no-padding"}>
                                                              <Tooltip title={"Remove Filter"}>
                                                                <IconButton
                                                                  aria-label={
                                                                    "deleteFilter" +
                                                                    +columnIndex +
                                                                    "C" +
                                                                    filterIndex
                                                                  }
                                                                  size={"small"}
                                                                  onClick={() =>
                                                                    this.deleteFilter(
                                                                      columnIndex,
                                                                      filterIndex
                                                                    )}
                                                                >
                                                                  <DeleteIcon
                                                                    style={{
                                                                      color:
                                                                        "var(--common--Text--color)"
                                                                    }}
                                                                    fontSize={"small"}
                                                                  />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                            <div className={"col-lg-5"}>
                                                              <FormControl
                                                                size={"small"}
                                                                error={this.getFilterErrorStatus(
                                                                  "key",
                                                                  filterIndex,
                                                                  columnIndex
                                                                )}
                                                              >
                                                                <InputLabel
                                                                  size={"small"}
                                                                  id={
                                                                    "filterKeyLabel" +
                                                                    columnIndex +
                                                                    "C" +
                                                                    filterIndex
                                                                  }
                                                                >
                                                                  {"On\r"}
                                                                </InputLabel>
                                                                <Select
                                                                  size={"small"}
                                                                  labelId={
                                                                    "filterKeyLabel" +
                                                                    +columnIndex +
                                                                    "C" +
                                                                    filterIndex
                                                                  }
                                                                  id={
                                                                    "filterKeySelect" +
                                                                    +columnIndex +
                                                                    "C" +
                                                                    filterIndex
                                                                  }
                                                                  defaultValue={
                                                                    filter.key
                                                                  }
                                                                  error={this.getFilterErrorStatus(
                                                                    "key",
                                                                    filterIndex,
                                                                    columnIndex
                                                                  )}
                                                                  helperText={
                                                                    this.getFilterErrorStatus(
                                                                      "key",
                                                                      filterIndex,
                                                                      columnIndex
                                                                    ) &&
                                                                    "Filter on field must be selected."
                                                                  }
                                                                  onChange={event => {
                                                                    this.handleFilterChange(
                                                                      event
                                                                        .target
                                                                        .value,
                                                                      "key",
                                                                      columnIndex,
                                                                      filterIndex
                                                                    );
                                                                  }}
                                                                >
                                                                  <MenuItem value={""}>
                                                                    <em>
                                                                      {"None\r"}
                                                                    </em>
                                                                  </MenuItem>
                                                                  {sampleData &&
                                                                    Object.keys(
                                                                      sampleData
                                                                    ).map(
                                                                      key => {
                                                                        return (
                                                                          <MenuItem
                                                                            size={"small"}
                                                                            value={
                                                                              key
                                                                            }
                                                                          >
                                                                            {
                                                                              key
                                                                            }
                                                                          </MenuItem>
                                                                        );
                                                                      }
                                                                    )}
                                                                </Select>
                                                                {this.getFilterErrorStatus(
                                                                  "key",
                                                                  filterIndex,
                                                                  columnIndex
                                                                ) && (
                                                                  <FormHelperText>
                                                                    {"Filter on\r"}
                                                                    {"field must\r"}
                                                                    {"be selected.\r"}
                                                                  </FormHelperText>
                                                                )}
                                                              </FormControl>
                                                            </div>
                                                            <div className={"col-lg-6"}>
                                                              {this.getInputForKey(
                                                                filter.key,
                                                                columnIndex,
                                                                filterIndex,
                                                                filter.values
                                                              )}
                                                              {/* <ChipInput
                                                                                label='Filter On'
                                                                                defaultValue={filter.values} 
                                                                                onChange={(chips) => this.handleFilterChange(chips, "key", columnIndex, filterIndex)}
                                                                            /> */}
                                                            </div>
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </fieldset>
                                              )}
                                          </div>
                                        </AccordionDetails>
                                      </Accordion>
                                    </>
                                  );
                                })}
                            </fieldset>
                          )}
                      </>
                    )}
                </div>

                <br />
                <div className={"col-lg-12"}>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    onClick={this.handlePreviewClickOpen}
                  >
                    {"Preview & save\r"}
                  </Button>
                </div>
                <Dialog
                  onClose={this.handlePreviewClose}
                  aria-labelledby={"responsive-dialog-title"}
                  open={openPreview}
                  fullWidth
                  maxWidth={"md"}
                  PaperComponent={PaperComponent}
                >
                  <DialogTitle
                    style={{ cursor: "move" }}
                    id={"responsive-dialog-title"}
                    onClose={this.handlePreviewClose}
                  >
                    {"Preview & Save\r"}
                  </DialogTitle>
                  <DialogContent dividers>
                    {openPreview && (
                      <>
                        {" "}
                        <span>{"Note: Preview is based on sample data."}</span>
                        {
                          <div
                            style={{ height: "400px" }}
                            id={"previewContainer_chart"}
                          >
                            <RenderLayout
                              propertyId={param.propertyId}
                              key={
                                "widget" +
                                chartConfig.usersWidgetMappingID +
                                chartConfig.widgetId
                              }
                              startDate={param.startDate}
                              endDate={param.endDate}
                              widgetconfig={chartConfig}
                              IsInPreviewMode
                              OpenWidgetConfigurationPanel={
                                this.OpenWidgetConfigurationPanel
                              }
                            />
                          </div>
                        }
                      </>
                    )}
                  </DialogContent>
                  <DialogActions>
                    {chartConfig.isClone != true && (
                      <Button
                        autoFocus
                        onClick={() => {
                          this.handlePreviewClose();
                          this.props.onSaveConfiguration(chartConfig);
                        }}
                        color={"primary"}
                      >
                        {"Save changes\r"}
                      </Button>
                    )}
                    {this.props.configureMaster != true && (
                      <Button
                        autoFocus
                        onClick={this.handleConfirmPreviewClickOpen}
                        color={"primary"}
                      >
                        {"Save As New\r"}
                      </Button>
                    )}
                    <Button
                      autoFocus
                      onClick={this.handlePreviewClose}
                      color={"primary"}
                    >
                      {"Cancel\r"}
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  onClose={this.handleConfirmPreviewClose}
                  key={"customized-Confirm-dialog"}
                  aria-labelledby={"customized-Confirm-dialog-title"}
                  open={openConfirmPreview}
                  fullWidth
                  maxWidth={"sm"}
                >
                  <DialogTitle
                    id={"customized-Confirm-dialog-title"}
                    onClose={this.handleConfirmPreviewClose}
                  >
                    {"Preview & Save\r"}
                  </DialogTitle>
                  <DialogContent dividers>
                    <p>{"Are you sure you want to save this as new widget?"}</p>
                    <TextField
                      id={"title"}
                      defaultValue={chartConfig.title || masterConfig.name}
                      onChange={event => {
                        this.handleChange(event.target.value, "title");
                      }}
                      label={"Override Title"}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() => {
                        chartConfig.usersWidgetMappingID = 0;
                        this.props.onSaveConfiguration(chartConfig);
                        this.setState({
                          openConfirmPreview: false,
                          openPreview: false
                        });
                      }}
                      color={"primary"}
                    >
                      {"Submit\r"}
                    </Button>

                    <Button
                      autoFocus
                      onClick={this.handleConfirmPreviewClose}
                      color={"primary"}
                    >
                      {"Cancel\r"}
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  fullScreen={false}
                  open={openViewSampleDataPanel}
                  maxWidth={"lg"}
                  onClose={this.handleSampleDataViewClose}
                  aria-labelledby={"responsive-dialog-title"}
                  PaperComponent={PaperComponent}
                >
                  <DialogTitle id={"responsive-dialog-title"}>
                    {"Sample Data\r"}
                  </DialogTitle>
                  <DialogContent>
                    {sampleViewData && (
                      <DenseTable
                        {...getPropsForData(
                          "details",
                          sampleViewData,
                          chartConfig,
                          null
                        )}
                        config={{ pagination: true }}
                      />
                    )}
                  </DialogContent>
                </Dialog>
              </form>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default ConfigureWidgetData;
